import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M21.75,0 L2.25,0 C1.00735931,0 0,1.00735931 0,2.25 L0,17.25 L0.00519081254,17.4040488 C0.084355084,18.5748384 1.05913601,19.5 2.25,19.5 L4.5,19.5 L4.5,23.25 L4.50713769,23.3562181 C4.58227796,23.9070344 5.23465676,24.1990074 5.7,23.85 L11.5,19.5 L21.75,19.5 C22.9926407,19.5 24,18.4926407 24,17.25 L24,2.25 C24,1.00735931 22.9926407,0 21.75,0 Z M2.25,1.5 L21.75,1.5 C22.1642136,1.5 22.5,1.83578644 22.5,2.25 L22.5,17.25 C22.5,17.6642136 22.1642136,18 21.75,18 L11.25,18 L11.1533483,18.0062528 C11.0256854,18.0228427 10.9038577,18.0721067 10.8,18.15 L6,21.75 L6,18.75 C6,18.3357864 5.66421356,18 5.25,18 L2.25,18 C1.83578644,18 1.5,17.6642136 1.5,17.25 L1.5,2.25 C1.5,1.83578644 1.83578644,1.5 2.25,1.5 Z' />
  </svg>
);
